import { render, staticRenderFns } from "./menora-audio-player.vue?vue&type=template&id=3384f704&scoped=true&"
import script from "./menora-audio-player.vue?vue&type=script&lang=js&"
export * from "./menora-audio-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384f704",
  null
  
)

export default component.exports